import { infrastructureArchitectureDiagramDataSelector } from "./infrastructureArchitectureDiagramDataSelector";
import { RootState } from "@/store/store";

export const infrastructureArchitectureDiagramSelector = (state: RootState) => {
  return infrastructureArchitectureDiagramDataSelector(state)?.diagram;
};
